var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M3.45 7.82H6v7.71c0 .25.3.45.66.45h2.66c.37 0 .67-.2.67-.45V7.82h2.55c.35 0 .57-.4.37-.7L8.37.21a.45.45 0 00-.75 0l-4.54 6.9c-.2.3.01.7.37.7z", "fill-rule": "nonzero" } }] }, name: "arrow-top", theme: "filled" };
export {
  a as default
};
